import React from 'react'
import { Box, Card, Divider, Stack, Typography } from '@mui/material'
import {
  UI_COLOR_DANGER_NEGATIVE,
  UI_COLOR_TEXT_BODY_DARK,
  UI_COLOR_TEXT_SUMMARY_LABEL,
  UI_COLOR_TEXT_SUMMARY_STRONG
} from '../constants/uiColors'

function TotalRow({
  label,
  value,
  strong = false,
  negative = false,
  noWrapLabel = false,
  compact = false
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2
      }}
    >
      <Typography
        sx={{
          fontSize: compact ? 14 : strong ? 16 : 14,
          fontWeight: strong ? 800 : 700,
          color: strong ? UI_COLOR_TEXT_SUMMARY_STRONG : UI_COLOR_TEXT_SUMMARY_LABEL,
          letterSpacing: 0.2,
          whiteSpace: noWrapLabel ? 'nowrap' : 'normal'
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          fontSize: compact ? 16 : strong ? 18 : 14,
          fontWeight: strong ? 800 : 500,
          color: negative ? UI_COLOR_DANGER_NEGATIVE : UI_COLOR_TEXT_BODY_DARK
        }}
      >
        {value}
      </Typography>
    </Box>
  )
}

export default function TotalsSummaryCard({
  rows = [],
  noWrapLabels = false,
  compact = false,
  maxWidth = 380
}) {
  const visibleRows = rows.filter(row => row && row.value !== undefined && row.value !== null)

  if (!visibleRows.length) return null

  return (
    <Box
      sx={{
        mt: 3,
        display: 'flex',
        justifyContent: { xs: 'center', md: 'flex-end' }
      }}
    >
      <Card
        elevation={0}
        sx={{
          width: '100%',
          maxWidth,
          borderRadius: 3,
          border: '1px solid #E5E7EB',
          background: 'linear-gradient(180deg, #FFFFFF 0%, #FAFBFC 100%)',
          boxShadow: '0 8px 24px rgba(15, 23, 42, 0.06)'
        }}
      >
        <Box sx={{ p: { xs: 2, sm: 3 } }}>
          <Stack spacing={2}>
            {visibleRows.map((row, index) => (
              <React.Fragment key={`${row.label}-${index}`}>
                {row.dividerBefore && <Divider />}
                <TotalRow
                  label={row.label}
                  value={row.value}
                  strong={row.strong}
                  negative={row.negative}
                  noWrapLabel={noWrapLabels}
                  compact={compact}
                />
              </React.Fragment>
            ))}
          </Stack>
        </Box>
      </Card>
    </Box>
  )
}
